import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'motion/react';
import { ArrowLeft } from 'lucide-react';
import { TOOLS_LIST } from '../tools/ToolsDirectoryPage';
import { ToolRenderer } from '../../components/tools/ToolRenderer';

export function ToolboxContainerPage() {
  const { slug: rawSlug } = useParams<{ slug: string }>();
  const slug = rawSlug?.replace(/\/$/, '');
  const navigate = useNavigate();

  const tool = TOOLS_LIST.find(t => t.slug === slug);

  if (!tool) {
    return (
      <div className="py-20 text-center border-[4px] border-black dark:border-white border-dashed bg-gray-50 dark:bg-[#050505]">
        <h3 className="text-2xl font-black uppercase tracking-tighter mb-2">Tool Not Found</h3>
        <p className="text-gray-500 font-bold mb-6">The requested utility does not exist or has been archived.</p>
        <button 
          onClick={() => navigate('/toolbox')}
          className="bg-black text-white dark:bg-white dark:text-black border-[4px] border-black dark:border-white font-black uppercase tracking-widest px-8 py-3 transition-colors cursor-pointer"
        >
          Back to Toolbox
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto space-y-8 animate-in fade-in zoom-in-95 duration-300 pb-16">
      {/* Back Navigation Bar */}
      <div className="flex justify-between items-center pb-4 border-b-[4px] border-black dark:border-white print:hidden">
        <button 
          onClick={() => navigate('/toolbox')}
          className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-black dark:text-white hover:text-[#0044FF] dark:hover:text-[#FFD600] transition-colors cursor-pointer"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Toolbox
        </button>
        <span className="border-[2px] border-black dark:border-white px-3 py-1.5 text-[10px] font-black uppercase tracking-widest bg-[#FFD600] text-black">{tool.category}</span>
      </div>

      {/* Intro Information */}
      <div className="space-y-4 mb-8 print:hidden">
        <h1 className="text-4xl md:text-5xl font-black font-display uppercase tracking-tighter text-black dark:text-white leading-[0.85] break-words">
          {tool.title}
        </h1>
        <h2 className="text-xl font-bold text-gray-700 dark:text-gray-300">
          {tool.description}
        </h2>
      </div>

      {/* Dynamic Interactive Components */}
      <div className="space-y-12 print:space-y-0 print:m-0">
        <ToolRenderer slug={slug || ''} />
      </div>
    </div>
  );
}
